<template>
    <div>
        <h5 class="mt-1 mb-3">{{ $t('general_information').toUpper() }}</h5>
        <b-row>
            <b-col cols="12" lg="12">
                <b-card :header="$t('student_information')" class="soft mb-5">
                    <b-row>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('student_number') }}</label>
                                <div>{{ studentProgram.student_number ? studentProgram.student_number : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('name') }}</label>
                                <div>{{ studentProgram.name ? studentProgram.name : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('surname') }}</label>
                                <div>{{ studentProgram.surname ? studentProgram.surname : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('student_status') }}</label>
                                <div>{{ studentProgram.student_status_text || "-" }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ isTeflProgram || isCeProgram ? $t('term_status') : $t('module_status') }}</label>
                                <div>{{ studentProgram.active_module_status }}</div>
                            </div>
                        </b-col>
                        <b-col v-if="!isYouthProgram" cols="12" lg="6">
                            <div class="label-as-input-div">
                                <label>{{ $t('placement_exam_test') }}</label>
                                <div>{{ studentProgram.placement_exam_level_name || "-" }}</div>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col cols="12" lg="6">
                <b-card :header="$t('registration_information')" class="soft mb-5">
                    <b-row>
                        <b-col v-if="!isYouthProgram" cols="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('registration_date') }}</label>
                                <div>{{ studentProgram.registration_date ? this.toLocaleDate(studentProgram.registration_date) : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col v-if="isTeflProgram || isCeProgram" cols="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('registration_start_date') }}</label>
                                <div>{{ studentProgram.registration_start_date ? this.toLocaleDate(studentProgram.registration_start_date) : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col v-if="isTeflProgram || isCeProgram" cols="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('registration_term') }}</label>
                                <div>{{ studentProgram.registration_term || '-' }}</div>
                            </div>
                        </b-col>
                        <b-col v-if="!isYouthProgram && !isTeflProgram && !isCeProgram" cols="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('registration_module') }}</label>
                                <div>
                                    {{ studentProgram.first_module_name ? studentProgram.first_module_name : '-' }}
                                </div>
                            </div>
                        </b-col>
                        <b-col v-if="!isYouthProgram && !isTeflProgram && !isCeProgram" cols="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('registration_session') }}</label>
                                <div>
                                    {{ studentProgram.first_session_number ? studentProgram.first_session_number : '-' }}
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('registration_type') }}</label>
                                <div>{{ studentProgram.registration_type_text || "-" }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('legal_presence_type') }}</label>
                                <div>{{ studentProgram.legal_presence_type || "-" }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('school_name') }}</label>
                                <div>{{ studentProgram.faculty_name || "-" }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('department_name') }}</label>
                                <div>{{ studentProgram.department_name || "-" }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('program_name') }}</label>
                                <div>{{ studentProgram.program_name || "-" }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12">
                          <div class="label-as-input-div">
                            <label>{{ $t('promotion_code') }}</label>
                            <div>{{ studentProgram.promotion_code  || "-" }}</div>
                          </div>
                        </b-col>
                    </b-row>

                </b-card>
            </b-col>
            <b-col cols="12" lg="6">
                <b-card :header="$t('agency_information')" class="soft mb-5">
                    <b-row>
                        <b-col cols="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('agency_code') }}</label>
                                <div>{{ studentProgram.agency_code  || "-" }}</div>
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('agency_name') }}</label>
                                <div>{{ studentProgram.agency_name  || "-" }}</div>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import ConstantService from "@/services/ConstantService";

    export default {
        props: {
            studentProgram: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                ceProgramCode: null
            }
        },
        computed: {
            isYouthProgram() {
                return this.studentProgram?.program_code === '0702004'
            },
            isTeflProgram() {
                return this.studentProgram?.program_code === '0702006'
            },
            isCeProgram() {
                return this.studentProgram?.program_code === this.ceProgramCode
            }
        },
        created() {
            ConstantService.getValuePrivate('ce_program_code').then(res => {
                if (res.data && res.data.data) {
                    this.ceProgramCode = res.data.data;
                }
            }).catch(() => {});
        }
    }
</script>

